import { spatialHeaderIconSize, fontSizes, iconButtonSize, inputHeight, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChangeTreeViewButton, FolderBrowserView } from "@iventis/tree-browser";
import { StaticLibrary } from "./mapping-library.helpers";

export const StaticLibraryHeader: React.FC<{
    staticLibrary: StaticLibrary;
    setViewType: (viewType: FolderBrowserView) => void;
    isLoading: boolean;
    viewType: FolderBrowserView;
}> = ({ staticLibrary, setViewType, isLoading, viewType }) => {
    const translate = useIventisTranslate();
    const text = translate(Content.library.static_library_names[staticLibrary.translationKey]);
    return (
        <StyledContainer>
            <div className="header-icon-container">
                <FontAwesomeIcon icon={["far", staticLibrary.icon]} />
            </div>
            {text}
            <StyledTreeViewButton text={translate(Content.library.folder_browser_view.while_in[viewType])} disabled={isLoading} viewType={viewType} onChange={setViewType} />
        </StyledContainer>
    );
};

const StyledTreeViewButton = styled(ChangeTreeViewButton)`
    margin-left: auto;
`;

const StyledContainer = styled.div`
    height: ${inputHeight};
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    white-space: nowrap;
    color: ${({ theme }: { theme: Theme }) => theme.shades.one};
    font-size: ${fontSizes.medium};
    font-weight: bold;

    .header-icon-container {
        width: ${iconButtonSize};
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .header-icon {
        width: ${spatialHeaderIconSize.width};
        height: ${spatialHeaderIconSize.height};
    }
`;
